import React, { useState, useEffect } from "react";

import "./style.css";
import BackIcon from "../../../Assets/Icons/BackIcon";
import NavbarCustom from "../../../Components/NavbarCustom";
import { Calendar } from "primereact/calendar";
import { useSession } from "../../../APIContext/SessionContext";
import { useNavigate } from "react-router-dom";
import "remixicon/fonts/remixicon.css";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import Logo from "../../../Assets/Images/company_logo.png";

export const ConfirmBooking = () => {
  const { selectedSportEvents, confirmBookingMsg } = useSession();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const sportId = params.get("sport_id");
  const saleId = params.get("sale_id");

  function getLocalTime(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  function getLocalDate(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString([], {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  function getLocalDay(utcDateTime) {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleDateString([], {
      weekday: "long",
    });
  }

  // useEffect(() => {
  //   const noEvents = !selectedSportEvents || selectedSportEvents.length === 0;
  //   const noMsg = !confirmBookingMsg || Object.keys(confirmBookingMsg).length === 0;

  //   if (noEvents && noMsg) {
  //     navigate('/');
  //   }
  // }, [selectedSportEvents, confirmBookingMsg, navigate]);

  return (
    <>
      <NavbarCustom />
      <div className="buy-packages-sports-container confirm-booking-container-pp">
        <div className="buy-packages-header">
          <BackBtn />
          <div className="buy-packages-header-content">
            <div className="booking-logo">
              <img src={Logo} alt="Company Logo" />
            </div>
            <h1 className="buy-packages-heading black-text-clip">
              {confirmBookingMsg.confirmed?.length > 0
                ? "Booking Confirmed!"
                : "No Sessions Booked"}
            </h1>
            <p className="buy-packages-subheading v-paragraph black-text-clip">
              {confirmBookingMsg.confirmed?.length > 0
                ? "Your session has been successfully scheduled"
                : ""}
            </p>
            <p className="buy-packages-subheading v-paragraph black-text-clip">
              {confirmBookingMsg.confirmed?.length > 0
                ? "A confirmation email has been sent to your inbox"
                : ""}
            </p>
          </div>
        </div>

        <div className="book-slots-container ">
          <div className="book-slots-body">
            <div className="popup-content">
              <div className="popup-list">
                <h3 className="black-text-clip">Booking Details</h3>
                {confirmBookingMsg.confirmed?.length > 0 ? (
                  confirmBookingMsg.confirmed?.map((event, index) => {
                    return (
                      <div key={event.id} className="popup-item">
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Event Name
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {event?.event_name}
                          </span>
                        </p>
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Location
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {event?.location}
                          </span>
                        </p>
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Player Name
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {event?.player_name}
                          </span>
                        </p>
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Day
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {getLocalDay(event.start_time_utc)}
                          </span>
                        </p>
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Time
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {getLocalTime(event.start_time_utc)} -{" "}
                            {getLocalTime(event.end_time_utc)}
                          </span>
                        </p>
                        <p className="popup-item-p">
                          <span className="popup-item-lable black-text-clip">
                            Date
                          </span>
                          <span className="popup-item-data black-text-clip">
                            {getLocalDate(event.start_time_utc)}
                          </span>
                        </p>
                      </div>
                    );
                  })
                ) : (
                  <p></p>
                )}

                {confirmBookingMsg.skipped?.length > 0 ? (
                  confirmBookingMsg.skipped?.map((event, index) => {
                    return (
                      <div key={event.id} className="popup-item">
                        <span className="black-text-clip">
                          {index + 1}) {event.event_name}
                        </span>
                        {/* <span>{getLocalDay(event.start_time_utc)}</span>
                            <span>{${getLocalTime(event.start_time_utc)} - ${getLocalTime(event.end_time_utc)}}</span>
                            <span>{getLocalDate(event.start_time_utc)}</span> */}
                        <span className="not-possible">Not Possible</span>
                        <span className="black-text-clip">{event.reason}</span>
                      </div>
                    );
                  })
                ) : (
                  <p></p>
                )}

                <div className="massages-with-details">
                  {confirmBookingMsg.remaining_sessions  && (
                    <>
                      <p className="popup-msg black-text-clip">
                        {confirmBookingMsg.confirmed?.length} Sessions from your
                        Basketball Package has been Deducted.
                      </p>

                      <p className="popup-msg black-text-clip">
                        You have {confirmBookingMsg.remaining_sessions} Sessions
                        Remaining in your Basketball Package.
                      </p>
                    </>
                  )}
                </div>
              </div>
              <div className="popup-buttons">
                <button
                  className="go-back-button"
                  onClick={() => navigate("/")}
                >
                  Go Back to Home
                </button>
                <button
                  className="book-sessions-button"
                  onClick={() => navigate("/view-all-sessions")}
                >
                  View All Sessions
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
